import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { RemarkService } from '../service/remark.service';
import { MatDialogRef } from '@angular/material';
var DeleteRemarkComponent = /** @class */ (function () {
    function DeleteRemarkComponent(_matDialogRef, data, _remarkService) {
        this._matDialogRef = _matDialogRef;
        this._remarkService = _remarkService;
        this.isLoading = false;
        this.remarkId = data.remarkId;
        this.airportId = data.airportId;
    }
    DeleteRemarkComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
    };
    DeleteRemarkComponent.prototype.close = function (data) {
        this._matDialogRef.close(data);
    };
    DeleteRemarkComponent.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.isLoading = true;
                        return [4 /*yield*/, this._remarkService.deleteRemark(this.airportId, this.remarkId)];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        this.close({ success: true });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.close({ success: false });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DeleteRemarkComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    return DeleteRemarkComponent;
}());
export { DeleteRemarkComponent };
